import { cn } from "@/lib/utils"

interface VitalCardProps {
  label: string
  value: number
  subtext: string
  variant: "critical" | "warning" | "healthy" | "dead"
}

export function VitalCard({ label, value, subtext, variant }: VitalCardProps) {
  return (
    <div
      className={cn(
        "bg-bg-body relative overflow-hidden px-6 py-5",
        "before:absolute before:inset-x-0 before:top-0 before:h-[2px] before:opacity-50",
        variant === "critical" && "before:bg-red-bright",
        variant === "warning" && "before:bg-yellow",
        variant === "healthy" && "before:bg-green-bright",
        variant === "dead" && "before:bg-bone-dim",
      )}
    >
      <div className="text-bone-dim font-mono text-[0.6rem] tracking-[0.1em] uppercase">
        {label}
      </div>
      <div
        className={cn(
          "font-display text-5xl leading-none",
          variant === "critical" &&
            "text-red-bright animate-pulse [text-shadow:0_0_20px_var(--red-glow)]",
          variant === "warning" && "text-yellow",
          variant === "healthy" && "text-green-bright",
          variant === "dead" && "text-bone",
        )}
      >
        {value}
      </div>
      <div className="text-bone-muted mt-0.5 font-mono text-[0.65rem]">
        {subtext}
      </div>

      {/* EKG Line Animation */}
      <div className="absolute inset-x-0 bottom-0 h-10 overflow-hidden opacity-15">
        <svg
          width="100%"
          height="40"
          preserveAspectRatio="none"
          className="absolute inset-0"
        >
          <path
            className={cn(
              "fill-none stroke-[2] [stroke-linecap:round] [stroke-linejoin:round]",
              variant === "critical" &&
                "stroke-red-bright animate-ekg-critical [stroke-dasharray:200]",
              variant === "warning" &&
                "stroke-yellow animate-ekg-warning [stroke-dasharray:200]",
              variant === "healthy" &&
                "stroke-green-bright animate-ekg-healthy [stroke-dasharray:200]",
              variant === "dead" && "stroke-bone-dim [stroke-dasharray:5,10]",
            )}
            d={
              variant === "dead"
                ? "M0,25 L400,25"
                : variant === "critical"
                  ? "M0,25 L20,25 L25,25 L30,10 L35,35 L40,20 L45,25 L100,25 L120,25 L125,25 L130,10 L135,35 L140,20 L145,25 L200,25 L220,25 L225,25 L230,10 L235,35 L240,20 L245,25 L300,25 L320,25 L325,25 L330,10 L335,35 L340,20 L345,25 L400,25"
                  : variant === "warning"
                    ? "M0,25 L30,25 L35,25 L40,15 L45,30 L50,22 L55,25 L100,25 L130,25 L135,25 L140,15 L145,30 L150,22 L155,25 L200,25 L230,25 L235,25 L240,15 L245,30 L250,22 L255,25 L300,25 L330,25 L335,25 L340,15 L345,30 L350,22 L355,25 L400,25"
                    : "M0,25 L40,25 L45,25 L50,18 L55,28 L60,23 L65,25 L100,25 L140,25 L145,25 L150,18 L155,28 L160,23 L165,25 L200,25 L240,25 L245,25 L250,18 L255,28 L260,23 L265,25 L300,25 L340,25 L345,25 L350,18 L355,28 L360,23 L365,25 L400,25"
            }
          />
        </svg>
      </div>
    </div>
  )
}
